import { SessionStorage } from 'common/helpers/Storage';

const AFTER_DEPLOY_REFRESHED_KEY = 'after_deploy_refreshed_at';
const TEN_MINUTES = 1000 * 60 * 10;

const lazy =
  <T>(lazyImport: () => Promise<T>) =>
  (fallback: T) =>
    lazyImport().catch((e) => {
      console.error(e);

      const now = Date.now();
      const refreshedAt = parseInt(
        SessionStorage.get(AFTER_DEPLOY_REFRESHED_KEY) || '0',
        10,
      );

      // maybe redeployed
      if (now - refreshedAt > TEN_MINUTES) {
        SessionStorage.set(AFTER_DEPLOY_REFRESHED_KEY, String(now));
        global.location.reload();
      }

      return fallback;
    });

export default lazy;
